import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { delay } from 'rxjs/operators';

import { LoginService } from 'src/app/services/login-service/login.service';
import { SdsFileService } from 'src/app/services/sds-repository-file/sds-file.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { filterSelectionState } from '../search-cars-component/search-cars.helper.consts';
import { StccsOption } from '../../models/stcc-option.model';

@Component({
  selector: 'app-client-profile',
  templateUrl: './client-profile.component.html',
  styleUrls: ['./client-profile.component.scss'],
})
export class ClientProfileComponent implements OnInit {
  clientData: any = null;
  loading = true;
  openDeleteModal = false;
  toggleAlertRailcarInventoryModal = false;
  openDownloadModal = false;
  moreFilesModal = false;
  isSort = true;

  isMostRecentOldest = true;
  isFavourite = false;
  isAlert = false;
  activeStcc: StccsOption | undefined;
  sorting = 'desc';
  favourite = '';
  alert = '';
  public uploadedFiles: any[] = [];
  public showingFileList = true;
  public files: any[] = [];
  deleteFileData: any;
  public awslocation: any;

  searchHistory: any;
  public sdsFileList: any[] = [];
  @ViewChild('fileDropRef') fileDropRef!: ElementRef;
  public deletedFileIndex!: number;
  dynamicData: any;
  public tab = '1';
  DownloadURL: any;

  constructor(
    private loginService: LoginService,
    private sdsService: SdsFileService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.loginService.getUser()?.subscribe({
      next: (response: any) => {
        this.clientData = response[0].json_build_object;
        this.loading = false;

        this.getSdsFile(this.clientData);
        this.sdsService
          .getUserSearchHistory(this.clientData)
          .subscribe((data) => {
            this.searchHistory = data;
          });
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      },
    });
  }

  ngOnInit(): void {}

  getSdsFile(clientData: any) {
    this.showingFileList = false;
    this.sdsService.getSdsFile(clientData).subscribe((res: any) => {
      this.sdsFileList = res;
      this.sortSDSFile(this.sdsFileList);
      this.cdr.detectChanges();
    });
  }

  canUploadSDSFile(event: Event) {
    console.log(event);

    const target = event.target as HTMLInputElement;
    if (target) {
      target.value = '';
      if (this.sdsFileList.length <= 5) {
        return true;
      } else {
        console.log('here');

        this.moreFilesModal = true;
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    }
    console.log('here');

    return false;
  }

  //handle file from browsing
  fileBrowseHandler(event: any) {
    this.showingFileList = true;
    console.log('here');

    if (this.sdsFileList.length === 5) {
      this.moreFilesModal = true;
      return;
    }
    if (event !== null) {
      const files = [...event.files];

      files.forEach((item: any) => {
        this.prepareFileList(item);
      });
    }
  }

  prepareFileList(file: File) {
    const fileReader = new FileReader();
    fileReader.onload = (event) => {
      const fileData = {
        file_name: file.name,
        file_path: URL.createObjectURL(file),
        sds_data: fileReader.result,
      };
      this.files.push(fileData);
    };
    fileReader.readAsDataURL(file);
    // this._holdFileService_.addFile ( file );
  }

  getAwsURL() {
    this.loading = true;
    const newFiles = this.files.filter(
      (file) =>
        !this.sdsFileList.some(
          (sdsFile) => sdsFile.file_name === file.file_name
        )
    );
    const numNewFiles = newFiles.length;
    const filesToUpload: {
      file_name: string;
      file_path: string;
      sds_data: string;
    }[] = []; // Specify the type of filesToUpload

    if (this.sdsFileList.length + numNewFiles > 5) {
      this.moreFilesModal = true;
      this.loading = false;

      return;
    }
    newFiles.forEach((file, index) => {
      this.sdsService
        .getPreassignedUrl(file)
        .pipe(delay(1000))
        .subscribe(
          (res: any) => {
            fetch(file.file_path)
              .then((response) => response.blob())
              .then((blob) => {
                this.uploadFileToAWS(res.url, blob).then(() => {
                  filesToUpload.push({
                    file_name: file.file_name,
                    file_path: res.url,
                    sds_data: file.sds_data,
                  });
                  if (index + 1 === numNewFiles) {
                    this.uploadFiles(filesToUpload);
                  }
                });
              });
          },
          () => {
            this.loading = false;
          }
        );
    });
  }

  uploadFileToAWS(url: any, file: any) {
    return this.sdsService.uploadFileToAWS(url, file).toPromise();
  }

  uploadFiles(filesToUpload: any[]) {
    if (filesToUpload.length > 0) {
      this.sdsService.submitSDSFile(filesToUpload[0]).subscribe(
        (res: any) => {
          this.sdsFileList.push(res);
          filesToUpload.shift();
          this.uploadFiles(filesToUpload);
        },
        (error) => {
          Swal.fire({
            position: 'top-end',
            text: error?.error?.message,
            timer: 1000,
            showConfirmButton: false,
          }).then((result: any) => {
            this.loading = false;
          });
          this.getSdsFile(this.clientData);
          this.loading = false;
        }
      );
    } else {
      this.files = [];
      this.getSdsFile(this.clientData);
      this.loading = false;
    }
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  deleteFileFromList(file: any) {
    const fileObj = this.sdsFileList.find((item: any) => item.id === file.id);
    this.deletedFileIndex = this.sdsFileList.indexOf(fileObj);
    this.openDeleteModal = true;
  }

  deleteApi() {
    this.loading = true;
    this.openDeleteModal = false;
    const fileToDelete = this.sdsFileList[this.deletedFileIndex];
    this.sdsService.deleteSdsFile(fileToDelete?.id).subscribe(
      (res: any) => {
        this.files = [];
        this.getSdsFile(this.clientData);
        this.loading = false;
      },
      (error: any) => {
        console.error('Error deleting file:', error);
        this.loading = false;
      }
    );
  }

  onLinkClick(jsonObj: any): void {
    const selectionConfig = JSON.parse(
      sessionStorage.getItem('selections') || '{}'
    );
    this.activeStcc = selectionConfig.StccObj || null;

    const { car_type, description_stcc } =
      jsonObj.user_search_input['user-filter'];
    const stccNumber = description_stcc.split('-')[1]?.trim();
    const stcc_description = description_stcc.split('-')[0].trim();

    const selectedCarType = jsonObj.user_search_input['selected-car-type'];

    const { model_id } = jsonObj.user_search_input['selected-cars'][0];

    const obj = {
      StccObj: {
        stcc: stccNumber,
        stcc_description: stcc_description,
        description_stcc: description_stcc,
        car_types: [car_type],
        model_ids: [model_id],
      },
      CarType: selectedCarType,
    };
    sessionStorage.setItem(filterSelectionState, JSON.stringify(obj));
    this.router.navigate(['/search-inventory/search-cars']);
  }

  toggleAlertRailcarInventory(item: any) {
    this.toggleAlertRailcarInventoryModal = true;
    this.dynamicData = item;
  }

  filteredList(item: string, sortTyep = '') {
    if (item === 'sorting') {
      this.isMostRecentOldest = !this.isMostRecentOldest;
      this.sorting = sortTyep === 'new' ? 'asc' : 'desc';
    }
    if (item === 'favourite') {
      this.isFavourite = !this.isFavourite;
      this.favourite = this.isFavourite ? 'true' : '';
    }
    if (item === 'alert') {
      this.isAlert = !this.isAlert;
      this.alert = this.isAlert ? 'true' : '';
    }
    this.sdsService
      .getUserSearchHistory(
        this.clientData,
        this.sorting,
        this.favourite,
        this.alert
      )
      .subscribe((data) => {
        this.searchHistory = data;
        this.loading = false;
      });
  }

  triggerupdateFavoriteApi(item: any) {
    this.loading = true;
    this.sdsService
      .updateFavoriteRailcarInventory(this.clientData, item.user_search_id)
      .subscribe(
        (res: any) => {
          if (res) {
            this.dynamicData = {};
            this.sdsService
              .getUserSearchHistory(this.clientData)
              .subscribe((data) => {
                this.searchHistory = data;
                this.loading = false;
              });
            this.isMostRecentOldest = false;
            this.isFavourite = false;
          }
          this.isMostRecentOldest = false;
          this.isFavourite = false;
        },
        (error: any) => {
          Swal.fire({
            position: 'top-end',
            text: 'An error occurred',
            timer: 1000,
            showConfirmButton: false,
          }).then((result: any) => {
            this.loading = false;
          });
          this.loading = false;
          return false;
        }
      );
  }

  triggerAlertApi(item: any) {
    this.loading = true;
    this.toggleAlertRailcarInventoryModal = false;
    this.sdsService
      .getAlertRailcarInventory(this.clientData, item.user_search_id)
      .subscribe(
        (res: any) => {
          if (res) {
            this.dynamicData = {};
            this.sdsService
              .getUserSearchHistory(this.clientData)
              .subscribe((data) => {
                this.searchHistory = data;
                this.loading = false;
              });
          }
          this.isMostRecentOldest = false;
          this.isFavourite = false;
        },
        (error) => {
          Swal.fire({
            position: 'top-end',
            text: 'An error occurred',
            timer: 1000,
            showConfirmButton: false,
          }).then((result: any) => {
            this.loading = false;
            this.dynamicData = {};
            this.toggleAlertRailcarInventoryModal = false;
          });
          this.loading = false;
          return false;
        }
      );
  }
  closeAlertModal() {
    this.toggleAlertRailcarInventoryModal = false;
    this.dynamicData = {};
  }
  utcToLocal(item: any) {
    return new Date(item);
  }
  changeTab(tabValue: any) {
    this.tab = tabValue;
  }
  calculateFileSize(item: any) {
    const blob = new Blob([item]);
    const size = (blob.size / (1024 * 1024)).toFixed(2);
    return size;
  }
  openDownloadModall(path: any) {
    this.openDownloadModal = true;
    this.DownloadURL = path;
  }
  download() {
    const url = this.DownloadURL.split('?Content-Type=application')[0];
    window.open(url, '_blank');
    this.DownloadURL = '';
  }
  closeDownloadModal() {
    this.DownloadURL = '';
    this.openDownloadModal = false;
  }
  sortSDSFile(data: any) {
    this.isSort = !this.isSort;
    data.sort((a: any, b: any) => {
      const dateA: any = new Date(a['created_date']);
      const dateB: any = new Date(b['created_date']);
      if (this.isSort) {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });
  }
  closeModal() {
    this.moreFilesModal = false;
  }
}
